import React from 'react';
import PropTypes from 'react-proptypes';
import { FormValue } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import THEME from '../../../shared/theme';

export default class ElementValueLabel extends React.Component {
  static propTypes = {
    value: PropTypes.instanceOf(FormValue).isRequired,
  };

  render() {
    // @ts-ignore
    const { styles } = ElementValueLabel;

    return (
      <div className={css(styles.label)}>
        {/* @ts-ignore */}
        {this.props.value.displayValue}
      </div>
    );
  }
}
// @ts-ignore
const styles = cssInJS({
  label: {
    paddingTop: 10,
    paddingLeft: 5,
    marginBottom: 10,
    fontSize: THEME.editFontSize,
    whiteSpace: 'pre-wrap',

    '@phone': {
      display: 'block',
      width: '100%',
      paddingLeft: 0,
    },
  },
});
// @ts-ignore
ElementValueLabel.styles = styles;
